import type { BreadcrumbList } from 'apps/commerce/types.ts'
import Icon from 'site/components/ui/Icon.tsx'
import c from '../../sdk/c.ts'

interface Props {
    itemListElement: BreadcrumbList['itemListElement']
    class?: string
}

const isValidHref = (href: unknown): href is string =>
    typeof href === 'string' && href.length > 0 && href !== 'undefined'

function Breadcrumb({ itemListElement = [], class: _class }: Props) {
    const items = [{ name: 'Home', item: '/' }, ...itemListElement]

    return (
        <ul class='flex gap-x-2 overflow-x-auto lg:pt-4 lg:pb-4 scrollbar-none'>
            {items
                .filter(({ name }) => name)
                .map(({ name, item }, i) => {
                    const className = c(
                        'whitespace-nowrap',
                        i === items.length - 1
                            ? 'text-secondary-700 font-bold'
                            : 'text-neutral-2',
                        _class,
                    )

                    return (
                        <li class='flex items-center gap-x-2 text-sm font-lato'>
                            {isValidHref(item)
                                ? <a href={item} class={className}>{name}</a>
                                : <span class={className}>{name}</span>}
                            {i !== items.length - 1 && (
                                <Icon id='BreadcrumbArrow' size={10} class='translate-y-px' />
                            )}
                        </li>
                    )
                })}
        </ul>
    )
}

export default Breadcrumb
